<template>
  <div class="infoClass">
    <brundCastV2 :pageTitle="pageTitle" :pageTitle0="pageTitle0">
      <el-input
        placeholder="请输入内容"
        v-model="inputValue"
        clearable
        @clear="searchValue"
        class="input-with-select"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchValue"
        ></el-button>
      </el-input>
    </brundCastV2>
    <router-view> </router-view>
  </div>
</template>

<script>
import brundCastV2 from "../components/brund_castV2.vue";
export default {
  components: {
    brundCastV2,
  },
  data() {
    return {
      pageTitle: "",
      inputValue: "",
    };
  },
  created() {
    this.pageTitle = localStorage.getItem("columnName");
    this.pageTitle0 = localStorage.getItem("columnName0");
    if (localStorage.getItem("columnName") == "首页") {
      this.pageTitle = "服务动态";
      localStorage.setItem("columnCode", localStorage.getItem("columnCode2"));
    }
  },
  methods: {
    searchValue() {
      this.$bus.$emit("search", {
        value: this.inputValue,
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .infoClass {
    min-height: 720px;
    background-color: #fff;
    width: 100%;
    margin: 10px 0;
  }
}

@media screen and (min-width: 750px) {
  .infoClass {
    min-height: 710px;
    background-color: #fff;
    width: 1200px;
    margin: 10px auto;
  }
}
</style>
